import React from "react"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"
import { Label } from "ui/components/atoms/typography"
import { BaseStyles } from "ui/types/base-styles"

export type RadioGroupProps = BaseStyles & {
  name: string
  value: string
  options: string[][]
  onChange?: (e: { name: string; value: string }) => void
}

const RadioGroup = ({
  name,
  value,
  options = [],
  onChange = () => {},
  ...rest
}: RadioGroupProps) => {
  const handleClick = (optionValue: string) => {
    onChange({
      name,
      value: optionValue,
    })
  }

  return (
    <Wrapper {...rest}>
      <ToggleGroup>
        {options.map((el: string[], index: number) => (
          <ToggleButton
            key={`${el[1]}`}
            type="button"
            $active={value === el[1]}
            $isFirst={index === 0}
            $isLast={index === options.length - 1}
            onClick={() => handleClick(el[1])}
          >
            <Label $type="third" $color={value === el[1] ? "white" : "second"}>
              {el[0]}
            </Label>
          </ToggleButton>
        ))}
      </ToggleGroup>
    </Wrapper>
  )
}

export default RadioGroup

const Wrapper = styled(Box)`
  * {
    box-sizing: border-box;
  }
`

const ToggleGroup = styled.div`
  display: inline-flex;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  // padding: ${({ theme }) => theme.space.XXS};
  background: ${({ theme }) => theme.color.background};
  overflow: hidden;
`

const ToggleButton = styled.button<{
  $active: boolean
  $isFirst: boolean
  $isLast: boolean
}>`
  padding: ${({ theme }) => theme.space.XS} ${({ theme }) => theme.space.S};
  background: ${({ $active, theme }) => ($active ? theme.color.primary : theme.color.background)};
  color: ${({ $active, theme }) => ($active ? theme.color.primary : theme.color.third)};
  border: none;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  * {
    cursor: pointer;
  }
`
